import { render, staticRenderFns } from "./JdSelectSku.vue?vue&type=template&id=0bc5b6ee&scoped=true&"
import script from "./JdSelectSku.vue?vue&type=script&lang=js&"
export * from "./JdSelectSku.vue?vue&type=script&lang=js&"
import style0 from "./JdSelectSku.vue?vue&type=style&index=0&id=0bc5b6ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5b6ee",
  null
  
)

export default component.exports